import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Locale config
import es419 from '@angular/common/locales/es-419';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

// Icons config
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faIcons } from './config/icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SharedModule } from './shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { LoaderService } from './shared/services/loader/loader.service';
import { HttpClientModule } from '@angular/common/http';
import { SessionServiceModule } from './shared/services/session/session-service.module';
import { ConfigSessionService } from './shared/services/session/interfaces/config-session.service';


registerLocaleData(es);
registerLocaleData(es419);
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    FontAwesomeModule,
    MatProgressSpinnerModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    SessionServiceModule.forRoot(new ConfigSessionService({cookieName: 'SM', activateAdminCookie: false})),
  ],
  providers: [LoaderService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
    library.addIconPacks(far);
    library.addIconPacks(fab);
    // @ts-ignore
    // library.addIcons(faIcons);
  }
}
